export default "<p>product-create works!</p>\n";